// // prod
// export default function AssignProductOwner(selectedProject) {
//   switch (selectedProject.toLowerCase()) {
//     // Sabari's tools
//     case "windvista":
//     case "windbug":
//     case "windvista_v2":
//       return "sabari.ram@wind-pioneers.com";

//     // Pradyumna's tools
//     case "windoscope":
//     case "windexgraph":
//       return "pradyumna.sripada@wind-pioneers.com";

//     // Bharath's tools
//     case "shear":
//     case "shear_v2":
//     case "shear_v3":
//     case "shearstandalone":
//     case "windscribe":
//       return "bharath.kuna@wind-pioneers.com, rohit.p@wind-pioneers.com, vijay.vasudevan@wind-pioneers.com ";

//     // Vijay's and Nikshep's tools
//     case "windwizz":
//       return "vijay.vasudevan@wind-pioneers.com, nikshep.raj@wind-pioneers.com";

//     // Shilpa's tools
//     case "coordinate plotter":
//     case "kml":
//       return "shilpa.shreekumar@wind-pioneers.com";

//     // Shreeja's tools
//     case "ltt":
//     case "lttstandalone":
//       return "shreeja.pujar@wind-pioneers.com";

//     // Bharan's tools
//     case "windcheck":
//     case "windcheckadmin":
//     case "weeklyreports":
//     case "batch uploader":
//       return "bharan.lekkad@wind-pioneers.com";

//     // Amlandeep's tools
//     case "monthlyreports":
//     case "windvista reports":
//     case "windvistareports":
//       return "amlandeep.baruah@wind-pioneers.com";

//     default:
//       return "Select";
//   }
// }

//beta
export default function AssignProductOwner(selectedProject) {
  switch (selectedProject.toLowerCase()) {
    case "windcheck":
    case "windcheckadmin":
    case "batch uploader":
    case "windvista v2":
    case "windvista_v2":
      return "nitin@sirpi.io";
    case "windwizz":
      return "vijay.vasudevan@wind-pioneers.com, nikshep.raj@wind-pioneers.com";
    case "windscribe":
      return "bharath.kuna@wind-pioneers.com, rohit.p@wind-pioneers.com";
    case "windexgraph":
    case "windoscope":
    case "shear_v2":
    case "shear_v3":
    case "shear":
    case "coordinate plotter":
    case "windvistareports":
      return "muzaffar@sirpi.io";
    case "windvista":
    case "windbug":
    case "ltt":
      return "vishal@sirpi.io";
    default:
      return "Select";
  }
}
